export default __webpack_public_path__ + "static/zillow_logo-ccb2520cd412f026541ab68939ade81c.png";